import { http } from "../../../services/apiSecurity/Http.interceptor";
import { ResponsePagination } from "../../../core/interfaces/ResponsePagination";
import Functionality from './interfaces/Functionality';
import { Pagination } from "../../../component/table/interfaces/Pagination";

const URL: string = '/funcionalidades';

export const getFunctionality = (params?: Pagination) => {
    return http.get<ResponsePagination>(URL, { params: params });
}

export const getByFunctionality = (id: number) => {
    return http.get<Functionality[]>(`${URL}/${id}`);
}

export const postFunctionality = (functionality: Functionality) => {
    return http.post<Functionality>(URL, functionality);
}

export const deleteFunctionality = (id: number) => {
    return http.delete<string>(`${URL}/${id}`);
}

export const putFunctionality = (functionality: Functionality) => {
    return http.put<Functionality>(`${URL}/${functionality.id}`, functionality);
}